/**
 * MyBranchInventoryPage
 * Redirects branch staff/admin to their assigned branch's inventory page.
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const MyBranchInventoryPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user?.current_branch_id) {
      navigate(`/branches/${user.current_branch_id}/inventory`, { replace: true });
    } else {
      // No branch assigned, redirect to branches list or dashboard
      navigate('/branches', { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-theme-primary flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-accent-gold animate-spin mx-auto mb-4" />
        <p className="text-theme-secondary">Loading your branch inventory...</p>
      </div>
    </div>
  );
};

export default MyBranchInventoryPage;
